var map = {
	"./allef-jordelly-vs-faz-ali.webp": 9866,
	"./allef-jordelly.webp": 10217,
	"./aron-kevinsson-vs-cain-morrow.webp": 14445,
	"./aron-kevinsson.webp": 66508,
	"./aron-leo.webp": 32154,
	"./cain-morrow.webp": 17059,
	"./cs37-logo.webp": 18207,
	"./duane-smith.webp": 13030,
	"./faz-ali.webp": 98447,
	"./gav-lofts-vs-aron-leo.webp": 56332,
	"./gav-lofts.webp": 83916,
	"./jack-terry.webp": 69649,
	"./joe-lister-vs-duane-smith.webp": 15197,
	"./joe-lister.webp": 11603,
	"./yonatan-francisco-vs-jack-terry.webp": 71495,
	"./yonatan-francisco.webp": 54692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25413;